import React from 'react';

/**
 * Component for displaying use case data with proper formatting
 */
const JsonViewer = ({ data }) => {
  // Extract use case data if available
  const useCase = data && data.use_case ? data.use_case : null;
  
  // Styles for the JSON viewer
  const viewerStyle = {
    padding: '15px',
    borderRadius: '5px',
    backgroundColor: 'var(--tertiary-bg)',
    border: '1px solid var(--border-color)',
    height: '100%',
    minHeight: '500px',
    overflow: 'auto',
    fontFamily: 'Consolas, Monaco, "Courier New", monospace',
    fontSize: '14px',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    textAlign: 'left',
    color: 'var(--primary-text)',
    lineHeight: '1.6'
  };

  const renderContent = () => {
    if (!data) {
      return 'No data selected. Click on a point in the plot.';
    }
    
    if (!useCase) {
      return 'No use case data available for this embedding.';
    }
    
    // If use_case is a string, display it directly
    if (typeof useCase === 'string') {
      return useCase;
    }
    
    // If use_case is an object, format it nicely
    if (typeof useCase === 'object') {
      // Sort keys so that 'title' appears first if present
      const entries = Object.entries(useCase).sort(([aKey], [bKey]) => {
        if (aKey === 'title') return -1;
        if (bKey === 'title') return 1;
        return 0;
      });

      return entries.map(([key, value]) => (
        <div key={key} style={{ marginBottom: '12px' }}>
          <div style={{ fontWeight: 'bold', color: 'var(--accent-color)' }}>{key}:</div>
          <div style={{ marginLeft: '16px' }}>{String(value)}</div>
        </div>
      ));
    }
    
    // Fallback to JSON.stringify for other types
    return JSON.stringify(useCase, null, 2);
  };

  return (
    <div>
      <h3>Use Case Data</h3>
      <div className="json-viewer">
        {renderContent()}
      </div>
    </div>
  );
};

export default JsonViewer; 